'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('property-list', {
      url: '/property/list',
      template: '<property-list></property-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/property-list/property-list.routes.js